import React, { useCallback } from 'react';
import CSelect, { Error } from 'src/components/form/Select';
import { DefaultTheme } from 'styled-components';
import { ActionMeta, Props, Theme } from 'react-select';
import { RiskSources, riskSourcesOptions } from 'src/api/types';

type Option = { label: string; value: RiskSources };

interface SourcesSelectProps extends Omit<Props<Option>, 'value'> {
  theme?: Theme & DefaultTheme;
  value?: RiskSources | null;
  onChange?: (value: Option, meta: ActionMeta<Option>) => void;
  placeholder?: string;
}
const getValue = (val?: RiskSources | null) => {
  const data = riskSourcesOptions.reduce<Option[]>((acc, curr) => [...acc, ...curr.options], []);
  return data.find((o) => o.value === val);
};

export const SourcesSelect: React.FC<SourcesSelectProps> = ({ value, placeholder = 'Select source', ...other }) => {
  const getOptionValue = useCallback((option: Option) => option.value, []);
  return (
    <>
      <CSelect
        value={getValue(value)}
        getOptionValue={getOptionValue}
        placeholder={placeholder}
        options={riskSourcesOptions}
        inputId="sources-select"
        {...other}
      />
      {other.error && other.helperText && <Error>{other.helperText}</Error>}
    </>
  );
};
